// src/components/claims/SourceRow.jsx
// One source of «Fonti consultate» (sources_consulted), linked only when the url is
// http(s) — a company document, an upload or any non-http source has none and says
// readers cannot open it. Then how many claims it backs and its quoted passages.
// No copy button (decision 15).
import React from 'react';
import { useTranslation } from 'react-i18next';
import { safeHttpUrl } from './claimsModel.js';
import { COLORS } from '../../constants/theme.js';

export default function SourceRow({ source, t = {} }) {
  const { t: tr } = useTranslation('outputs');
  const muted = t.textMuted || COLORS.textSecondary;
  const href = safeHttpUrl(source.url);
  const backs = Array.isArray(source.claim_ids) ? source.claim_ids.length : 0;
  return (
    <li style={{ padding: '8px 0', fontSize: '12.5px', lineHeight: 1.5, color: t.text || COLORS.ink }}>
      {href
        ? <a href={href} target="_blank" rel="noopener noreferrer" style={{ color: COLORS.accent }}>{source.title}</a>
        : <span>{source.title}</span>}
      {!href && <span style={{ color: muted }}> {tr('claims.unlinked')}</span>}
      {backs > 0 && <div style={{ fontSize: '11px', color: muted }}>{tr('claims.backs', { count: backs })}</div>}
      {(source.passages || []).filter((p) => p?.text).map((p, i) => (
        <div key={i} style={{ fontSize: '11.5px', color: muted, marginTop: '2px' }}>«{p.text}»</div>
      ))}
    </li>
  );
}
